import { lazy } from "react";
import { Txt } from "../Localized";

const PaymentSuccess = lazy(() => import("../../Pages/Public/PaymentResult/PaymentSuccess"));
const FindReport = lazy(() => import("../../Components/Public/FindReport/FindReport"));
const MainPage = lazy(() => import("../../Pages/Public/MainPage"));
const Blog = lazy(() => import("../../Pages/Public/Blog"));
const FullArticle = lazy(() => import("../../Components/Public/Blog/FullArticle/FullArticle"));
const AboutUs = lazy(() => import("../../Pages/Public/AboutUs/AboutUs"));
const ContactUs = lazy(() => import("../../Pages/Public/ContactUs/ContactUs"));
const Pricing = lazy(() => import("../../Pages/Public/Pricing/Pricing"));
const AiAgent = lazy(() => import("../../Pages/Public/AiAgent/AiAgent"));
const WhereIsVin = lazy(() => import("../../Pages/Public/WhereIsVin/WhereIsVin"));
const ContactInfluencer = lazy(() => import("../../Pages/Public/ContactInfluencer/ContactInfluencer"));
const ShoppingCartLayout = lazy(() => import("../../Components/Public/ShoppingCart/ShoppingCartLayout"));
const ShoppingCartVin = lazy(() => import("../../Components/Public/ShoppingCart/Main/ShoppingCartVin/ShoppingCartVin"));
const ShoppingCartEmail = lazy(() => import("../../Components/Public/ShoppingCart/Main/ShoppingCartEmail/ShoppingCartEmail"));
const ShoppingCartSummary = lazy(() => import("../../Components/Public/ShoppingCart/Main/ShoppingCartSummary/ShoppingCartSummary"));
const PressArea = lazy(() => import("../../Pages/Public/PressArea/PressArea"));
const PaymentFailed = lazy(() => import("../../Pages/Public/PaymentResult/PaymentFailed"));
const StudentSale = lazy(() => import("../../Pages/Public/StudentSale/StudentSale"));
const CouponCart = lazy(() => import("../../Components/Public/ShoppingCart/Coupon/CouponCart/CouponCart"));
const CouponCartSummary = lazy(() => import("../../Components/Public/ShoppingCart/Coupon/CouponCartSummary/CouponCartSummary"));
const SinglePurchase = lazy(() => import("../../Components/Public/ShoppingCart/SinglePurchase/SinglePurchase"));
const MainShoppingBar = lazy(() => import("../../Components/Public/ShoppingCart/Main/MainShoppingBar"));
const CouponBar = lazy(() => import("../../Components/Public/ShoppingCart/Coupon/CouponBar"));
const SinglePurchaseBar = lazy(() => import("../../Components/Public/ShoppingCart/SinglePurchase/SinglePurchaseBar"));
const EmailHtml = lazy(() => import("../special_routes/emails/EmailHtml"));
const PaymentResult = lazy(() => import("../../Pages/Public/PaymentResult/PaymentResult"));
const ResultPage = lazy(() => import("../../Pages/ResultPage/ResultPage"));
const ShoppingCartSearch = lazy(() => import("../../Components/Public/ShoppingCart/Main/ShoppingCartSearch/ShoppingCartSearch"));
const CarsPage = lazy(() => import("../../Pages/Public/CarsPage/CarsPage"));
const ErrorPage = lazy(() => import("../../Pages/CZ/ErrorPage/ErrorPage"));
const ObchodniPodminky = lazy(() => import("../../Pages/CZ/Legal/ObchodniPodminky"));

const shoppingHandle = {
    public: true,
    hideNavbar: true,
    hideFooter: true,
    backgroundColor: '#F8F8FC',
    appbarColors: {
        top: '#F8F8FC',
        main: 'white',
    },
};

const greyBGHandle = {
    public: true,
    backgroundColor: '#F8F8FC',
    appbarColors: {
        top: '#F8F8FC',
        main: 'white',
    },
};

// skipCheck - vin check
const shoppingCartRoutes = [
    /* MAIN */
    {
        index: true,
        element: <ShoppingCartVin />,
        handle: { ...shoppingHandle, navbar: MainShoppingBar, navbarProps: { toText: "info@carskaut.com", noLink: true } }
    },
    {
        path: 'vin/:vin',
        element: <ShoppingCartVin />,
        handle: { ...shoppingHandle, navbar: MainShoppingBar, navbarProps: { toText: "info@carskaut.com", showPCNav: true, noLink: true } }
    },
    {
        path: 'email',
        element: <ShoppingCartEmail />,
        handle: { ...shoppingHandle, navbar: MainShoppingBar }
    },
    {
        path: 'summary',
        element: <ShoppingCartSummary />,
        handle: { ...shoppingHandle, navbar: MainShoppingBar, navbarProps: { toText: "info@carskaut.com", noLink: true } }
    },
    /* MAIN VIN START */
    {
        path: 'search',
        element: <ShoppingCartSearch />,
        handle: { ...shoppingHandle, skipCheck: true, navbar: MainShoppingBar }
    },
    /* COUPONS USAGE */
    {
        path: 'coupon',
        element: <CouponCart />,
        handle: { ...shoppingHandle, skipCheck: true, navbar: CouponBar, navbarProps: { showPCNav: true } }
    },
    {
        path: 'coupon_summary',
        element: <CouponCartSummary />,
        handle: { ...shoppingHandle, skipCheck: true, navbar: CouponBar }
    },
    /* ONLY PURCHASE */
    {
        path: 'purchase',
        element: <SinglePurchase />,
        handle: { ...shoppingHandle, skipCheck: true, navbar: SinglePurchaseBar }
    },
    {
        path: 'purchase/:count',
        element: <SinglePurchase />,
        handle: { ...shoppingHandle, skipCheck: true, navbar: SinglePurchaseBar }
    },
];

const defaultRoutes = [
    {
        path: "*",
        element: <ErrorPage />,
    },
    {
        index: true,
        element: <MainPage />,

    },
    {
        path: "cars/:car_name",
        element: <CarsPage />,
        handle: {
            namespace: ['car', 'main'],
        },
    },
    {
        path: "cart",
        element: <ShoppingCartLayout />,
        children: shoppingCartRoutes,
        helmetId: 4,
    },
    {
        path: "terms",
        element: <ObchodniPodminky />,
        handle: { langOnlySwitch: true },
    },
    {
        path: "cookies",
        element: <ObchodniPodminky cookies={true} />,
        handle: { langOnlySwitch: true },
    },
    {
        path: "privacy",
        element: <ObchodniPodminky privacy={true} />,
        handle: { langOnlySwitch: true },
    },
    {
        path: "blog",
        element: <Blog />,
        helmetId: 11,
    },
    {
        path: "contact",
        element: <ContactUs />,
        helmetId: 7,
    },
    {
        path: "influencer",
        element: <ContactInfluencer />,
        helmetId: 18,
    },
    {
        path: "student",
        element: <StudentSale />,
        helmetId: 19,
    },
    {
        path: "press",
        element: <PressArea />,
        helmetId: 9,
    },
    {
        path: "about",
        element: <AboutUs />,
        helmetId: 6,
    },
    {
        path: "ai_agent",
        element: <AiAgent />,
        helmetId: 14,
    },
    {
        path: "find_vin",
        element: <WhereIsVin />,
        helmetId: 15,
    },
    {
        path: "find_report",
        element: <FindReport />,
    },
    {
        path: "pricing",
        element: <Pricing />,
        helmetId: 4,
    },
    {
        path: "article/:id",
        element: <FullArticle />,
    },
    {
        path: "error",
        element: <ErrorPage />,
        helmetId: 16,
    },
    {
        path: "result",
        element: <ResultPage />,
        handle: {
            hideNavbar: true,
            hideFooter: true,
            result: true,
            namespace: ['result', 'main'],
        }
    },
    {
        path: "result/sample",
        element: <ResultPage />,
        handle: {
            hideNavbar: false,
            hideFooter: true,
            result: true,
            namespace: ['result', 'main'],
        }
    },
    {
        path: "result/:id",
        element: <ResultPage />,
        handle: {
            hideNavbar: true,
            hideFooter: true,
            result: true,
            namespace: ['result', 'main'],
        }
    },

    // PAYMENT RESULT
    {
        path: "payment_failed",
        element: <PaymentFailed />,
        helmetId: 17,
        handle: {
            result: true,
        }
    },
    {
        path: "payment/:id",
        element: <PaymentResult />,
        handle: {
            result: true,
        }
    },
    {
        path: "payment",
        element: <PaymentResult />,
        handle: {
            result: true,
        }
    },
    {
        path: "payment_success",
        element: <PaymentSuccess />,
        handle: {
            result: true,
        }
    },
    // SPECIAL ROUTES
    {
        path: "email/view/:id",
        element: <EmailHtml />,
        handle: { ...greyBGHandle }
    },
];
export default defaultRoutes;
